<template>
  <div>
    <div class="header-area">
      <span>{{ $t('pages.personal.statistics') }}</span>
    </div>
    <div class="info-area">
      <div class="oper-area">
        <div class="btn-area">
          <el-button
            class="my-btn"
            type="primary"
            size="mini"
            @click="toExport"
          >
            <i class="iconfont">&#xe612;</i>
            <span>{{ $t('common.exports') }}</span>
          </el-button>
          <!-- <div class="dropdown-area">
            <el-dropdown @command="changeType">
              <el-button class="my-btn" type="primary" size="small">
                {{ type | typeText }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="''">全部</el-dropdown-item>
                <el-dropdown-item :command="'1'">已解答</el-dropdown-item>
                <el-dropdown-item :command="'0'">未解答</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div> -->
        </div>
        <div class="search-area">
          <el-cascader
            class="orgs"
            expandTrigger="hover"
            size="small"
            :show-all-levels="false"
            :props="{ checkStrictly: true }"
            v-model="orgIds"
            :options="orgList"></el-cascader>
          <el-input
            size="small"
            :placeholder="$t('common.placeHolder_enter')"
            v-model="keywords"
            class="input-with-select"
            clearable
            @clear="toSearch"
            @keyup.enter.native="toSearch"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="toSearch"
            ></el-button>
          </el-input>
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        :data="list"
        border
        v-loading="isLoading"
        size="medium"
        style="width: 100%"
      >
        <el-table-column
          :label="$t('pages.personal.courseName')"
          prop="courseName"
          align="center"
        />
        <el-table-column
          :label="$t('pages.personal.credits')"
          width="100"
          prop="credit"
          align="center"
        />
        <el-table-column
          :label="$t('pages.personal.duration')"
          prop="duration"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.duration | handleTime }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('pages.personal.completeness')"
          prop="courseOverCre"
          align="center"
        />
        <el-table-column
          :label="$t('pages.personal.passRate')"
          prop="oneDoneCres"
          align="center"
        />
      </el-table>
      <div class="pagination-area">
        <el-pagination
          :current-page.sync="page"
          :page-size="pageSize"
          :hide-on-single-page="true"
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
          @current-change="getData"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { baseURL } from '@/config';
import { selectStatisticsOfOrg, selectOrgStructureInfo } from '@/api/common';
export default {
  data() {
    return {
      keywords: '',
      isLoading: false,
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      orgIds: [],
      orgList: []
    };
  },
  methods: {
    toSearch() {
      this.page = 1;
      this.getData();
    },
    async toExport () {
      // console.log(this.$store, baseURL, axios)
      // return
      axios(
          {
            url: `${baseURL}/ruihe/Study/export`,
            method: 'post',
            data: {
              courseName: this.keywords
            },
            responseType: 'blob',
            headers: {
              'content-disposition': `attachment;filename=xls`,
              'content-type': 'application/json',
              'Authorization': `pBearer ${this.$store.state.token}`,
            },
          }
        )
        .then((res) => {
          console.log(res);
          let blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel',
          });
          let objectUrl = URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = objectUrl;
          a.download = 'memberList';
          //a.click();
          //下面这个写法兼容火狐
          a.dispatchEvent(
            new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window,
            })
          );
          window.URL.revokeObjectURL(blob);
        });
    },
    async getData() {
      this.isLoading = true;
      try {
        const res = await selectStatisticsOfOrg({
          courseName: this.keywords,
          pageNum: this.page,
          pageSize: this.pageSize,
          orgIds: this.orgIds.length > 0 ? this.orgIds[this.orgIds.length - 1] : ''
        });
        this.total = res.total;
        this.list = res.data;
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async getTreeData(type) {
      try {
        const res = await selectOrgStructureInfo({ seeType: type || '' });
        this.orgList = res;
        this.orgIds = res[0].value
      } catch (error) {
        console.log(error);
      }
    },
    // orgChange (data) {
    //   console.log(data, this.value)
    // }
  },
  created() {
    this.getTreeData(1)
    this.getData();
    
  },
};
</script>

<style lang="scss" scoped>
.header-area {
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #f7f7f7;
  padding: 0 30px;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search-area {
  display: flex;
  align-items: center;
  .orgs {
    margin-right: 10px;
  }
}
.info-area {
  padding: 20px 30px 60px;
  .oper-area {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    justify-content: space-between;
    .btn-area {
      .my-btn {
        i.iconfont {
          margin-right: 5px;
        }
        span {
          span {
            display: inline-block;
            transform: translateY(1px);
          }
        }
      }
    }
  }
  .content {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .video-timing {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #777;
    user-select: none;
    cursor: pointer;
    .iconfont {
      margin-right: 5px;
    }
  }
  ::v-deep .el-table {
    border: 1px solid #ebeef5;
    border-bottom: none;
    th {
      background: #f7f7f7;
      &.el-table-column--selection {
        .cell {
          padding-left: 14px;
        }
      }
    }
  }
  .pagination-area {
    // border: 1px solid #EBEEF5;
    border-top: none;
    padding: 50px 0 18px;
    .el-pagination {
      text-align: center;
    }
  }
}
</style>
